import { render, staticRenderFns } from "./GuardarContacto.vue?vue&type=template&id=741b2568&"
import script from "./GuardarContacto.vue?vue&type=script&lang=js&"
export * from "./GuardarContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports